// Retention classes as people read them: a title in the UI language and the
// period written out ("5 years · EPK", «Постоянно»). Shared by the console's
// Retention tab and the Records area.

import { latinToCyrillic } from '@/shared/utils/translitUzCyrl.js';

export const PERIOD_KINDS = ['years', 'permanent', 'until_replaced', 'until_not_needed'];
export const TITLE_LANGUAGES = ['uz', 'uz-Cyrl', 'ru', 'en'];

const FALLBACK = {
  'uz-Cyrl': ['uz-Cyrl', 'uz', 'ru', 'en'],
  uz: ['uz', 'uz-Cyrl', 'ru', 'en'],
  ru: ['ru', 'uz', 'en', 'uz-Cyrl'],
  en: ['en', 'ru', 'uz', 'uz-Cyrl'],
};

// The title in `lang`, else the nearest one there is. A Cyrillic reader gets
// the Latin Uzbek title transliterated before falling back to Russian.
export function titleIn(title, lang) {
  const t = title || {};
  if (lang === 'uz-Cyrl' && !t['uz-Cyrl'] && t.uz) return latinToCyrillic(t.uz);
  const order = FALLBACK[lang] || FALLBACK.en;
  const hit = order.find((k) => t[k]);
  return hit ? t[hit] : '';
}

// `t` from the `records` namespace.
export function periodLabel(item, t) {
  if (!item) return '';
  const text = item.period_kind === 'years'
    ? t('records:period.years', { count: item.period_years || 0 })
    : t(`records:period.kinds.${item.period_kind}`);
  return item.epk ? `${text} · ${t('records:period.epk')}` : text;
}

export const PLAN_STATUS_TONE = {
  draft: 'border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300',
  approved: 'border-green-200 dark:border-green-800 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300',
  closed: 'border-border bg-muted/50 text-muted-foreground',
};
